import { ref, useContext } from "@nuxtjs/composition-api";
import { Logger } from "~/helpers/logger";

export function useFirstLoginCheckShop() {
	const { app } = useContext();
	const loading = ref(false);
	const error = ref({
		search: null,
		load: null,
	});

	const search = async (params) => {
		let res;
		let customerShop;
		let errorMsg = null;

		try {
			loading.value = true;

			Logger.debug("[Magento]: firstLoginCheckShop", { params });

			// @ts-ignore
			res = await app.$vsf.$magento.api.firstLoginCheckShop(params);
			customerShop = res?.data?.firstLoginCheckShop;
			if (!customerShop && res?.errors) {
				errorMsg = res.errors[0].message;
			}

			Logger.debug("[Result]: firstLoginCheckShop", customerShop);
		} catch (err) {
			error.value.search = err;
			Logger.error("useFirstLoginCheckShop/search", err);
		} finally {
			loading.value = false;
		}

		return { customerShop, errorMsg };
	};

	return {
		search,
	};
}

export default useFirstLoginCheckShop;
